import * as React from "react";

export interface LogoProps {
  src: string;
  alt: string;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
  trademarkClassName?: string;
}

export function Logo({ src, alt, height, className, style, trademarkClassName }: LogoProps) {
  const heightVar = typeof height === "number" ? `${height}px` : (height ?? "1em");
  return (
    <span className="relative inline-flex items-center whitespace-nowrap leading-none">
      <img src={src} alt={alt} className={className} style={{ ...style, height, width: "auto" }} />
      <span
        className={`font-normal ${trademarkClassName ?? ""}`}
        style={{
          fontSize: `calc(${heightVar} * 0.45)`,
          lineHeight: 1,
          transform: "translateY(-60%)",
        }}
        aria-hidden="true"
      >
        ™
      </span>
    </span>
  );
}
